<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('EditWorkHours') | ToUppercase">
                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="date"></datepicker>

                <small>{{$t('Shift') |ToUppercase}}</small><br>
                <vs-select v-model="shiftId" class="selectExample w-full mb-3">
                    <vs-select-item v-for="(item,index) in shifts" :key="index" :text="item.name" :value="item.id"/>
                </vs-select>
                
                <small>{{ $t("ExtraHours") | ToUppercase }}</small><br>
                <vs-input class="w-full mb-6" type="number" step="0.5" name="name" v-model="extraHours"/>

                <small>{{ $t("Explanation") | ToUppercase }}</small><br>
                <vs-input class="w-full mb-6" type="text" name="name" v-model="explanation"/>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="editWorkHours">{{ $t("Edit") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                workHourId: 0,
                date: null,
                shifts: {},
                shiftId: 0,
                extraHours: 0,
                explanation: '',
            };
        },
        methods: {
            editWorkHours() {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.put("/work-hour/", {
                    id: thisIns.workHourId,
                    date: thisIns.date,
                    extra_hours: parseFloat(thisIns.extraHours),
                    explanation: thisIns.explanation,
                    shift_id: thisIns.shiftId,
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Ure shranjene",
                        color: "success",
                    });
                    thisIns.$router.push('/work-hours/all');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateWorkHour() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/work-hour/' + this.workHourId)
                .then(function (response) {
                    thisIns.workHourId = response.data.id;
                    thisIns.date = response.data.date;
                    thisIns.shiftId = response.data.shift_id;
                    thisIns.extraHours = response.data.extra_hours;
                    thisIns.explanation = response.data.explanation;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju opravljenih ur",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateShifts() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/')
                .then(function (response) {
                    console.log(response);
                    thisIns.shifts = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju izmen",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
        },
        created() {
            this.workHourId = this.$route.params.work_hour_id;
            this.updateWorkHour();
            this.updateShifts();
        },
    };
</script>